import { useTranslation } from 'react-i18next';

interface SkipLinkProps {
  targetId: string;
  children: React.ReactNode;
}

export function SkipLink({ targetId, children }: SkipLinkProps) {
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.focus();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      data-skip-link
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      aria-label={t('accessibility.skipLink.label', 'דלג לתוכן הראשי')}
    >
      {children}
    </a>
  );
}

export function SkipToMain() {
  const { t } = useTranslation();
  
  return (
    <SkipLink targetId="main-content">
      {t('accessibility.skipLink.main', 'דלג לתוכן הראשי')}
    </SkipLink>
  );
}

export function SkipToNavigation() {
  const { t } = useTranslation();
  
  return (
    <SkipLink targetId="main-navigation">
      {t('accessibility.skipLink.navigation', 'דלג לניווט')}
    </SkipLink>
  );
} 